export { default as IconFallbackOrg } from './icon-fallback-org.svg';
export { default as IconFallbackUser } from './icon-fallback-user.svg';
